import React, { useState, useEffect, useContext } from 'react';
import '../../css/leftarrow.css';
import leftarrow from '../img/leftarrow.jpg'
import { functionContext } from '../../App'


function Leftarrow(props) {

const { changeLevelLeft } = useContext(functionContext);
// const levelNumber = Object.values(level)

  // console.log("left arrow" + props.selectedLevel)

  return (
    <>
      <div id="left-arrow">
      <img src={leftarrow} alt="arrowbutton" id="right-arrow" onClick={() => changeLevelLeft(props.selectedLevel)}></img>
      </div>
    </>
  )
}

export default Leftarrow;
